import { v4 as uuidv4 } from 'uuid';

const eventKey = "userNotifications";

export function on(callback: (ev: any) => any) {
  window.addEventListener(eventKey, callback);
}

export const dispatchCustom = (data: IUserNotification) => {
  window.dispatchEvent(new CustomEvent(eventKey, { detail: data }));
};

export const dispatchFromError = (friendlyMessage: string, errorFromApi: any, timeout: any = undefined) => {
  const data = parseUserNotification(UserNotificationType.Error, friendlyMessage, timeout, errorFromApi);
  dispatchCustom(data);
};

export const dispatch = (friendlyMessage: string, timeout: any = undefined, type: UserNotificationType = UserNotificationType.Success) => {
  const data = parseUserNotification(type, friendlyMessage, timeout);
  dispatchCustom(data);
}

export function remove(callback: (ev: any) => any) {
  window.removeEventListener(eventKey, callback);
};

export enum UserNotificationType {
  Success = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
}

export interface IValidationError {
  errorCode: string;
  fieldName: string;
  message: string;
}

export interface IUserNotification {
  id: string;
  type: UserNotificationType;
  friendlyHeader: string;
  friendlyMessage: string;
  serverStatusCode: number;
  serverStatusMessage: string;
  validationErrors?: IValidationError[];
  timeout?: number;
  removeAt: number;
  addedAt: number;
  cssClass?: string;
}

export function parseUserNotification(notificationType: UserNotificationType, friendlyMessage: string, timeout: any = undefined, reason: any = null): IUserNotification {
  let message = {} as IUserNotification;
  message.id = uuidv4(); // ⇨ '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d'
  message.type = notificationType;
  message.friendlyMessage = friendlyMessage;
  if (timeout) {
    if (!isNaN(timeout)) {
      message.timeout = timeout;
    }
    else {
      if (timeout) {
        message.timeout = 5;
      }
    }
  }
  //console.log("parseUserNotification reason=", reason, reason.data);
  if (reason) {
    if (reason.status) {
      message.serverStatusCode = reason.status;
    }
    if (reason.statusText) {
      message.serverStatusMessage = reason.statusText;
    }
    if (reason.data && reason.data.responseStatus) {
      if (reason.data.responseStatus.message) {
        message.serverStatusMessage = reason.data.responseStatus.message;
      }
      if (reason.data.responseStatus.errors && reason.data.responseStatus.errors.length > 0) {
        message.validationErrors = reason.data.responseStatus.errors;
        message.friendlyMessage = "Valideringsfel";
      }
    }
  }
  if (message.type == UserNotificationType.Error) {
    message.cssClass = "alert-danger";
  } else if (message.type == UserNotificationType.Warning) {
    message.cssClass = "alert-warning";
  } else if (message.type == UserNotificationType.Information) {
    message.cssClass = "alert-info";
  } else if (message.type == UserNotificationType.Success) {
    message.cssClass = "alert-success";
  }
  if (message.type == UserNotificationType.Error) {
    message.friendlyHeader = "Fel";
  } else if (message.type == UserNotificationType.Warning) {
    message.friendlyHeader = "Varning";
  } else if (message.type == UserNotificationType.Information) {
    message.friendlyHeader = "Information";
  }

  return message;
}

